export type ShowElementsMultiEditMode = {
	cutoff: boolean;
	service_plan_ids: boolean;
	service_area_ids: boolean;
	fee: boolean;
};
export const initialDataOFShowElements = {
	cutoff: false,
	service_plan_ids: false,
	service_area_ids: false,
	fee: false
};
